import React from 'react'
import classes from './BeneficiaryPassword.module.css'
import SettingsWrapper from '../SettingsWrapper'
import { ValidatedFormInput } from '../../../components/Form/Inputs/Inputs'
import { Button } from '../../../components/Button/Button'
import { ResetPasswordSchema } from '../../../util/formSchemas'
import { Formik } from 'formik'
import usePasswordForm from '../../../hooks/usePasswordForm'

const BeneficiaryPassword = () => {
    const submitForm = usePasswordForm()

    return (
        <SettingsWrapper title="Change Password">
            <Formik
                initialValues={{
                    oldPassword: '',
                    newPassword: '',
                    confirmNewPassword: '',
                }}
                validationSchema={ResetPasswordSchema}
                onSubmit={submitForm}
            >
                {({ handleSubmit }) => (
                    <>
                        <h1 className={classes.formHeader}>Password</h1>
                        <p className={classes.formSubtext}>
                            Please provide your current password and choose a
                            new password.
                        </p>
                        <div className={classes.formInputs}>
                            <ValidatedFormInput
                                label={'Current Password'}
                                name={'oldPassword'}
                                type={'password'}
                            />
                            <ValidatedFormInput
                                label={'New Password'}
                                name={'newPassword'}
                                type={'password'}
                            />
                            <ValidatedFormInput
                                label={'Retype Password'}
                                name={'confirmNewPassword'}
                                type={'password'}
                            />
                        </div>
                        <Button onClick={handleSubmit}>Save Password</Button>
                    </>
                )}
            </Formik>
        </SettingsWrapper>
    )
}

export default BeneficiaryPassword
